import { useState } from 'react';

export default function useCounter(defaultValue = 0) {
    const [ counter, setCounter ] = useState(defaultValue);

    const increment = () => setCounter(counter + 1);

    return [ counter, increment ];
}